import React from "react";
import { TextField, SelectBox, RadioButton } from "../../primary";
import { AddOptionDropDown } from "./addOptionDropDown";
import { ProductAttributeDivision } from "./productAttributeDivision";
import { TextBox } from "./textBox";
import styles from "./assign.module.scss";
import { checkCoreDescription } from "../../../utils";
import { BranchDropdown } from "./branchDropdown";
import { MediaList } from "./mediaList";
import QuestionAnswer from "./questionAnswer";

export const QuestionBody = ({
  qvalue,
  pIndex,

  customFormBuilder,
  formData,
  branch,
  addBranchIndex,
  getRuleIndex,
  dropRef,

  register,
  errors,
  showQuestionError,
  getQutions,
  getQutionsCoreDesc,
  selectAnswerType,
  getAttributeVal,
  fetchValue,
  getGotoValue,
  getInputValue,
  addRuleData,
  addBranch,
  addBranchValue,
  addNewQuestionOption,

  addMedia,
  handleAddMedia,
  handleAddMediaCancel,
  setcustomFormBuilder,
  setSectionInfo,

  getOptionValue,
  deleteAnswerOption,
  productFamilyCode,
  productMaterialCode,
  productAttributeOrderChange,
}) => {
  let defaultGotoOption = [
    { value: "Next", key: "next" },
    { value: "End of form", key: "eof" },
  ];
  let dataOption = [];
  [...customFormBuilder].map((value, formIndex) => {
    return (dataOption = [...dataOption, { value: `${formIndex + 1} - ${value.desc}`, key: `${formIndex + 1}` }]);
  });
  let gotoOption = [...defaultGotoOption, ...dataOption.splice(pIndex + 2, dataOption.length)];
  let value = { ...qvalue };
  let other = value?.options?.find((o) => o.value === "Others");
  let alloftheabove = value?.options?.find((o) => o.value === "All of the above");
  let noneoftheabove = value?.options?.find((o) => o.value === "None of the above");
  value.addOption =
    value.addOption === undefined
      ? [
          { key: "1", value: "Add answer", visible: 1 },
          { key: "2", value: "Add other", visible: other ? 0 : 1 },
          { key: "3", value: "Add all of the above", visible: alloftheabove ? 0 : 1 },
          { key: "4", value: "Add none of the above", visible: noneoftheabove ? 0 : 1 },
        ]
      : value.addOption;

  let branchOption = value.type !== "singleselect" ? ["Add for question"] : ["Add for question", "Add for options"];
  return (
    <>
      <TextField
        id={`text${value.id}`}
        name={`text${value.id}`}
        classes={{
          column: `col-5 ${styles.col_spec} ${"err_val" + pIndex}`,
          labelClass: `col-1 col-form-label ${styles.label_spec}`,
          inputColumn: `col-11 p-0 outline`,
          inputClassName: `${styles.basic_input} getQues ml-5`,
        }}
        type="text"
        validator={register()}
        errors={errors}
        placeholder={"Type here"}
        value={value.desc}
        onChange={(e) => getQutions(e.target.value, pIndex)}
        title={value.desc}
      />
      <MediaList
        media={value?.media}
        addMedia={addMedia}
        handleAddMedia={handleAddMedia}
        handleAddMediaCancel={handleAddMediaCancel}
        questionId={value?.id ? value?.id : 0}
        formId={formData?.id}
        questionIndex={pIndex}
        customFormBuilder={customFormBuilder}
        setcustomFormBuilder={setcustomFormBuilder}
        setSectionInfo={setSectionInfo}
        dropRef={dropRef}
      />
      {(value.optionType === null || value.optionType === undefined || value.optionType === "default") && (
        <SelectBox
          id={`questionType${pIndex}`}
          name={`questionType${pIndex}`}
          label={`Type:`}
          classes={{
            column: `col-5 ${styles.col_spec}`,
            inputClassName: `${styles.type_basic_select} selectAnswer`,
            labelClassName: `col-3 col-form-label ${styles.type_label_spec}`,
            inputColumn: `col-9 p-0 ${styles.select_wrapper}`,
          }}
          optionValue={[
            { key: "singleselect", value: "Single Select" },
            { key: "multiselect", value: "Multi Select" },
            { key: "text", value: "Text Box" },
          ]}
          placeholder={"Select type"}
          validator={register()}
          errors={errors}
          defaultValue={value.type}
          onChange={(e) => selectAnswerType(e.target.value, pIndex)}
          customForm={true}
        />
      )}
      <TextField
        id={`coretext${pIndex}`}
        name={`coretext${pIndex}`}
        classes={{
          column: `col-9 ${styles.col_spec} ml-5  mt-n3 mb-1`,
          labelClass: `col-1 col-form-label ${styles.label_spec}`,
          inputColumn: `col-6 p-0 outline`,
          inputClassName: `${styles.basic_input_core_des} ${value.coreDesc ? styles.basic_input_core_foc : ""} getQues`,
        }}
        type="text"
        validator={register(checkCoreDescription)}
        errors={errors}
        placeholder={"Description"}
        defaultValue={value.coreDesc}
        onChange={(e) => getQutionsCoreDesc(e.target.value, pIndex)}
      />

      {showQuestionError && showQuestionError?.index === pIndex ? (
        <div className="col-12 pb-4 ml-0 mt-0 mb-n4">
          <span className={`${styles.error_message} ${styles.pl_32}`}>{`Please enter question ${value.type !== "text" ? "and options" : ""}`}</span>
        </div>
      ) : (
        false
      )}
      {formData?.assignInfo?.feature !== "NE1 WMS" && (
        <>
          {value.optionType === null ||
          value.optionType === undefined ||
          value.optionType === "default" ||
          value.optionType === "productattribute" ||
          value.optionType === "productfamily" ||
          value.optionType === "productmaterial" && (
            <div className={`ml-5 col-6 ${styles.col_spec} mb-0`}>
              <div className={`col-sm-12 p-0`}>
                <label className={`col-5 col-form-label mr-0 ${styles.label_in_spec}`}>Product Attribute:</label>
                <RadioButton
                  id={`productattribute${pIndex}`}
                  name={`productattribute${pIndex}`}
                  classes={{
                    labelClass: `custom-control-label col-form-label ${styles.custom_control_label}`,
                    inputClassName: `custom-control-input ${styles.custom_control_input}`,
                    inputColumn: "custom-control custom-radio custom-control-inline",
                  }}
                  validator={register}
                  radioOption={["Yes", "No"]}
                  defaultValue={value.optionType === "productattribute" ? "Yes" : ""}
                  onChange={(e) => getAttributeVal(e, pIndex, "productattribute")}
                  onClick={(e) => getAttributeVal(e, pIndex, "productattribute")}
                />
              </div>
            </div>
          )}
          {(value.optionType === null ||
            value.optionType === undefined ||
            value.optionType === "default" ||
            value.optionType === "productattribute" ||
            value.optionType === "productfamily" ||
            value.optionType === "productmaterial") && (
            <div className={`ml-5 col-6 ${styles.col_spec} mb-0`}>
              <div className={`col-sm-12 p-0`}>
                <label className={`col-5 col-form-label mr-0 ${styles.label_in_spec}`}>Product Family:</label>
                <RadioButton
                  id={`productfamily${pIndex}`}
                  name={`productfamily${pIndex}`}
                  classes={{
                    labelClass: `custom-control-label col-form-label ${styles.custom_control_label}`,
                    inputClassName: `custom-control-input ${styles.custom_control_input}`,
                    inputColumn: "custom-control custom-radio custom-control-inline",
                  }}
                  validator={register}
                  radioOption={["Yes", "No"]}
                  defaultValue={value.optionType === "productfamily" ? "Yes" : ""}
                  onChange={(e) => getAttributeVal(e, pIndex, "productfamily")}
                  onClick={(e) => getAttributeVal(e, pIndex, "productfamily")}
                />
              </div>
            </div>
          )}
          {(value.optionType === null ||
            value.optionType === undefined ||
            value.optionType === "default" ||
            value.optionType === "productattribute" ||
            value.optionType === "productfamily" ||
            value.optionType === "productmaterial") && (
            <div className={`ml-5 col-6 ${styles.col_spec} mb-2`}>
              <div className={`col-sm-12 p-0`}>
                <label className={`col-5 col-form-label mr-0 ${styles.label_in_spec}`}>Product Material #:</label>
                <RadioButton
                  id={`productmaterial${pIndex}`}
                  name={`productmaterial${pIndex}`}
                  classes={{
                    labelClass: `custom-control-label col-form-label ${styles.custom_control_label}`,
                    inputClassName: `custom-control-input ${styles.custom_control_input}`,
                    inputColumn: "custom-control custom-radio custom-control-inline",
                  }}
                  validator={register}
                  radioOption={["Yes", "No"]}
                  defaultValue={value.optionType === "productmaterial" ? "Yes" : ""}
                  onChange={(e) => getAttributeVal(e, pIndex, "productmaterial")}
                  onClick={(e) => getAttributeVal(e, pIndex, "productmaterial")}
                />
              </div>
            </div>
          )}
        </>
      )}
      {value.optionType === "productattribute" && (
        <div className="col-sm-12">
          <div className={`${styles.product_sub_block}`}>
            <ProductAttributeDivision
              fetchValue={(val, res, attr) => fetchValue(val, res, attr)}
              index={pIndex}
              defaultValue={value?.productAttributeFilter}
            />
          </div>
        </div>
      )}
      {value.type !== "text" ? (
        value.options.map((optionValue, optionIndex) => (
          <QuestionAnswer
            key={optionIndex}
            questionValue={value}
            pIndex={pIndex}
            value={optionValue}
            index={optionIndex}
            gotoOption={gotoOption}
            getOptionValue={getOptionValue}
            getGotoValue={getGotoValue}
            deleteAnswerOption={deleteAnswerOption}
            productFamilyCode={productFamilyCode}
            productMaterialCode={productMaterialCode}
            addRuleData={addRuleData}
            productAttributeOrderChange={productAttributeOrderChange}
          />
        ))
      ) : (
        <TextBox
          id="entertext"
          index={pIndex}
          pIndex={pIndex}
          getGotoValue={getGotoValue}
          goto={value.goto}
          gotoOption={gotoOption}
          getInputValue={getInputValue}
          placeholder={value.placeholder}
        />
      )}
      {value.type !== "text" && value.goto !== "" && value.goto !== undefined && value.goto !== null && (
        <>
          <div className="col-7"></div>
          <SelectBox
            id={"Goto"}
            name={"Goto"}
            label={`Go to:`}
            classes={{
              column: `col-3 ${styles.col_spec}`,
              inputClassName: `${styles.type_basic_select} select_Goto`,
              labelClassName: `col-4 col-form-label ${styles.type_label_spec}`,
              inputColumn: `col-12 p-0 ${styles.select_wrapper}`,
            }}
            optionValue={gotoOption}
            defaultValue={value.goto}
            onChange={(e) => getGotoValue(e.target.value, pIndex)}
            customForm={true}
          />
        </>
      )}
      {formData?.assignInfo?.feature !== "NE1 WMS" && value?.goto === "eof" && value?.rule !== undefined && (
        <div className="col-2 p-0">
          <button type="button" className={`btn ${styles.btn_custom_rule} w-auto`} onClick={() => addRuleData(value.rule, pIndex)}>
            {value.rule === null || value.rule === undefined ? "Add Rule" : "Edit Rule"}
          </button>
        </div>
      )}
      {getRuleIndex.includes(value?.id) && (
        <div className="col-12 text-right">
          <span className={`${styles.error_message} ${styles.pr_90}`}>{`One or more questions have been deleted, please review the rule.`}</span>
        </div>
      )}
      {value.type !== undefined && value.type !== "" && (
        <div className={`col-6 ${styles.col_spec}`}>
          <div className={"col-3 p-0 offset-1"}>
            <button type="button" className={`btn ${styles.btn_custom_branch} addbranch ml-3`} onClick={() => addBranch(pIndex)} ref={dropRef}>
              Branching
            </button>
            <BranchDropdown
              branch={branch}
              index={pIndex}
              addBranchIndex={addBranchIndex}
              addBranchValue={addBranchValue}
              options={branchOption}
              dropRef={dropRef}
            />
          </div>
          {value.type !== "text" && value.optionType === "productfamily" && (
            <AddOptionDropDown
              addNewQuestionOption={addNewQuestionOption}
              type={value.type}
              parentIndex={pIndex}
              addOption={value.addOption}
              clsName={value.type}
            />
          )}
          {value.type !== "text" && value.optionType === "productattribute" && (
            <div className={"col-4 p-0"}>
              <button
                type="button"
                className={`btn ml-5 w-auto ${styles.btn_custom_branch_answer}`}
                onClick={() => addNewQuestionOption({ key: "1", value: "Add answer", visible: 1 }, "singleselect", pIndex)}
              >
                Add Answer
              </button>
            </div>
          )}
          {value.type !== "text" && value.optionType === "productmaterial" && (
            <AddOptionDropDown
              addNewQuestionOption={addNewQuestionOption}
              type={value.type}
              parentIndex={pIndex}
              addOption={value.addOption}
              clsName={value.type}
            />
          )}
          {((value.type !== "text" && value.optionType === null) || (value.type !== "text" && value.optionType === "default")) && (
            <AddOptionDropDown
              addNewQuestionOption={addNewQuestionOption}
              type={value.type}
              parentIndex={pIndex}
              addOption={value.addOption}
              clsName={value.type}
            />
          )}
        </div>
      )}
    </>
  );
};
